module.exports = __webpack_public_path__ + "static/img/03.44d43f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20250618/03.png
// module id = +vSH
// module chunks = 0